import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { ImgixImage } from "../../ImgixImage";
export const ProfileCover = (param)=>{
    let { src , className , children  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("relative w-full h-[250px] overflow-hidden rounded-b-2xl md:h-[350px] lg:h-[336px] lg:rounded-2xl group bg-neutral-200", className),
        children: [
            src && /*#__PURE__*/ _jsx(ImgixImage, {
                fill: true,
                src: src,
                alt: "Profile cover",
                className: "object-cover"
            }),
            children
        ]
    });
};
